class LoginController {
    // @ngInject
    constructor($state, $rootScope, $scope, localStorageService, authService, CONSTANTS, $window) {
        this.state = $state;
        this.Root = $rootScope
        this.scope = $scope



        // $scope.buildVersion = CONSTANTS.BUILD_VERSION
        $scope.buildVersion = "5.0"
        $scope.newUser = {}
        function reloadPage() {
            // location.reload();
            _showPrompt(1)
            initGapi()
        }
        function parseJwt(token){
            try{
                let base64Url = token.split('.')[1];
                let base64 = base64Url.replace('-', '+').replace('_', '/');
                return JSON.parse($window.atob(base64));
            }catch(e){
                console.log(e)
                return null
            }

        }
        function onOneTapSignedIn(data) {
            try{
                let user = parseJwt(data.credential);
                if(user && user.email && user.email_verified){
                    _hidePrompt()
                    _loginFromOneTap(user)
                }else{
                    // reloadPage()
                    console.log('client parse error')
                }
            }catch(e){
                console.log(e)
                // reloadPage()
                console.log('client parse error')
            }
        }
        function _doNothing(){

        }
        function initializeOneTap(){
            try{
                google.accounts.id.initialize({
                    client_id: CONSTANTS.GC_CLIENT_ID,
                    cancel_on_tap_outside: false,
                    style:{
                        position: 'absolute', top: '1px', right: '30px',
                        width: 0, height: 0, 'z-index': '1001'
                    },
                    type: "icon",
                    theme: "filled_blue",
                    callback: onOneTapSignedIn,
                    prompt_parent_id: "root",
                    intermediate_iframe_close_callback: _doNothing
                });
                google.accounts.id.prompt((notification) => {
                    try{
                        if (notification.isNotDisplayed()) {
                            console.log(notification.getNotDisplayedReason());
                        } else if (notification.isSkippedMoment()) {
                            console.log(notification.getSkippedReason());
                        } else if (notification.isDismissedMoment()) {
                            console.log(notification.getDismissedReason());
                        } else {
                            if (notification.isSkippedMoment() && notification.getSkippedReason() === 'user_cancel') {
                                // do fallback logic
                                console.log(notification)
                            }
                        }
                    }catch(gE){
                        console.log(gE)
                    }
                })
            }catch(eRR){
                console.log(eRR)
            }
        }
        function _showPrompt(){
            let _DOM = document.getElementById("credential_picker_container");
            if(_DOM){
                _DOM.style.display = "block";
            }
            let GBTN_DOM = document.getElementById("buttonDiv");
            if(GBTN_DOM){
                GBTN_DOM.style.display = "block";
            }
        }
        function _hidePrompt(){
            let _DOM = document.getElementById("credential_picker_container");
            if(_DOM){
                _DOM.style.display = "none";
            }
            let GBTN_DOM = document.getElementById("buttonDiv");
            if(GBTN_DOM){
                GBTN_DOM.display = "none";
            }
        }
        function loadOneTapLogin() {
            if(!google.accounts || !google.accounts.id){
                window.onGoogleLibraryLoad = () => {
                    initializeOneTap()
                }
            }else{
                initializeOneTap()
            }
        }
        function _loginFromOneTap(resp){
            try{
                authService.callAPI("/v1/gsuit_login_auth", "POST", resp, function (response) {
                    if (response.result != undefined) {
                        let result = response.result.data.data[0]        
                        try {
                            let empOrAdmnNo = result.admission_number ? result.admission_number : result.employeeNo
                            let userBatchDetails = result.name
                            if (result.admission_number)
                                userBatchDetails = result.sessionName + "/" + result.curriculumName + "/" + result.className + "/" + result.batchName + "/" + result.name
                            _paq.push(['setCustomVariable', 1, "School ID", result.school_name, "visit"]);
                            _paq.push(['setCustomVariable', 2, "Role IDs", result.role_ids, "visit"]);
                            _paq.push(['setCustomVariable', 3, "Login Username ", result.quick_login_id, "visit"]);
                            _paq.push(['setCustomVariable', 4, "Admn No/Emp No ", empOrAdmnNo, "visit"]);
                            _paq.push(['setCustomVariable', 5, "User Details", userBatchDetails, "visit"]);
                            _paq.push(['setUserId', result.username]);
                            _paq.push(['trackPageView']);
                        } catch (e) {
                            console.log(e);
                        }
                        // matomo analytics code ends

                        if (result.admission_number){
                            localStorageService.set("className", result.className)
                        }
                        localStorageService.set("allAcademic_year", result.allAcademic_year)
                        localStorageService.set("is_login", true)
                        localStorageService.set("school_id", result.school_id)
                        localStorageService.set("school_name", result.school_name)
                        localStorageService.set("academic_year", result.academic_year)
                        localStorageService.set("user_id", result.user_id)
                        localStorageService.set("role_ids", result.role_ids)
                        localStorageService.set("full_name", result.name)
                        localStorageService.set("activeAcdYear", result.academic_year)
                        localStorageService.set("admission_no", result.admission_number)
                        localStorageService.set("username", result.username)
                        localStorageService.set("user_image", result.image)
                        localStorageService.set("active_time_check", result.active_time_check)
                        localStorageService.set('login_timestamp', new Date().getTime());
                        localStorageService.set("full_name", result.name)
                        localStorageService.set("mobile", result.phone)
                        localStorageService.set("user_address", result.addrLine1+","+result.addrLine2+","+result.city+","+result.country)        
                        localStorageService.set("module_privileges", result.module_privileges)
                        localStorageService.set("feature_privileges", result.feature_privileges)
                        $rootScope.username = result.name

                        if(result.feeDuePopup){
                            localStorageService.set("feedue_popup", result.feeDuePopup);
                            if(result.feedue_popup_message){
                                localStorageService.set("feedue_popup_message", result.feedue_popup_message);
                            }
                        }
                        if(result.bannerstatus){
                                localStorageService.set("bannerstatus", result.bannerstatus);
                        }

                        // if(result.password_tracking){ 
                        //     localStorageService.set("password_tracking", true)
                        // } 

                        let userAccessJson = _.filter(localStorageService.get('feature_privileges'), function (feature) {
                            return feature.module_state === "childrenComponent"
                        });
                        if (userAccessJson && userAccessJson.length) {
                            _.each(userAccessJson, function (feature) {
                                let user_access = {};
                                _.each(feature.privilege, function (privObj) {
                                    user_access[privObj.name.toLowerCase()] = privObj.status
                                })
                                localStorageService.set('parent_user_access', user_access);
                                $rootScope.userRoleParentAccess = localStorageService.get('parent_user_access');
                                _.defer(function () {
                                    $scope.$apply();
                                });;
                            })
                        }

                        $rootScope.isLoggedIn = true
                        let toredirected = localStorageService.get('toredirected')
                        if(toredirected && toredirected.student_id &&
                            toredirected.qp_id && toredirected.page &&
                            toredirected.parent_id &&
                             toredirected.parent_id ==  result.user_id){
                                $state.go("activityReportViaLinkCtrl", {
                                    student_id: toredirected.student_id,
                                    qp_id: toredirected.qp_id,
                                    page : toredirected.page,
                                    teacher_id : toredirected.teacher_id,
                                    parent_id : result.user_id
                                })
                            }else{
                                $state.go("dashboard")
                            }
                    } else {
                        let msg = response.error.error.message;
                        //$scope.signOut();
                        toastr.error(msg);
                        reloadPage()
                    }
                });
            }catch(eR){
                console.log(eR)
                reloadPage()
            }
        }
        function handleGgOneTap(data){

        }
        function handleCredentialResponse(data){

        }
        function initializeGoogle() {
            let self = this
            google.accounts.id.initialize({
                client_id: CONSTANTS.GC_CLIENT_ID,
                callback: onOneTapSignedIn,
                theme: "filled_white"
            });
            google.accounts.id.prompt();
            // google.accounts.id.initialize({
            //     client_id: CONSTANTS.GC_CLIENT_ID,
            //     callback: onOneTapSignedIn
            // });
            google.accounts.id.renderButton(
                document.getElementById("buttonDiv"),
                { size: "large", theme: "filled_white", 'width': 337 ,}
            );
        }
        $scope.showHide = () => {
            let showForm = $scope.showForm
            if(showForm){
                
            }else{
            }
        }
        function initGapi() {
            try{
                
                gapi.load('auth2', function() {
                    initializeGoogle()
                })
                
                // gapi.load('auth2', function() {
                //     /* Ready. Make a call to gapi.auth2.init or some other API */
                //     $scope.renderButton();
                // });
            }catch(e){
                console.log(e)
            }
        }
        this.$onInit = () => {  
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if ($rootScope.isLoggedIn) {
                $state.go("dashboard")
            } else {
                _showPrompt(1)
                // loadOneTapLogin()
                initGapi()
            //$scope.signOut();
            }
            $rootScope.title = "Login"
        }
        $scope.loginUser = () => {
            $scope.newUser.userAgent = "web";

            if ($scope.newUser.username && $scope.newUser.password) {
                _hidePrompt(2)
                authService.callAPI("/v1/login_auth", "POST", $scope.newUser, function (response) {

                    if (response.result != undefined) {
                        let result = response.result.data.data[0]

                        // matomo analytics code starts
                        try {
                            if(response.result.data.sessionId != undefined){
                                localStorageService.set("sessionId", response.result.data.sessionId);
                            }
                            var empOrAdmnNo = result.admission_number ? result.admission_number : result.employeeNo
                            var userBatchDetails = result.name
                            if (result.admission_number)
                                userBatchDetails = result.sessionName + "/" + result.curriculumName + "/" + result.className + "/" + result.batchName + "/" + result.name
                            // _paq.push(['setCustomVariable', 1, "School ID", result.school_name, "visit"]);
                            // _paq.push(['setCustomVariable', 2, "Role IDs", result.role_ids, "visit"]);
                            // _paq.push(['setCustomVariable', 3, "Login Username ", result.quick_login_id, "visit"]);
                            // _paq.push(['setCustomVariable', 4, "Admn No/Emp No ", empOrAdmnNo, "visit"]);
                            // _paq.push(['setCustomVariable', 5, "User Details", userBatchDetails, "visit"]);
                            _paq.push(['setCustomDimension', 1, result.school_name]);
                            _paq.push(['setCustomDimension', 2, result.role_ids]);
                            _paq.push(['setCustomDimension', 3, result.quick_login_id]);
                            _paq.push(['setCustomDimension', 4, empOrAdmnNo]);
                            _paq.push(['setCustomDimension', 5, userBatchDetails]);
                            _paq.push(['setUserId', result.username]);
                            _paq.push(['trackPageView']);
                            
                            // google analytics----------------
                            gtag('set', 'user_properties', {
                                'school_name': result.school_name,
                                'user_data': userBatchDetails,
                                'user_id': $scope.newUser.username,
                                'role_id': result.role_ids,
                            });
                            // ---------------google analytics

                        } catch (e) {
                            console.log(e);
                        }
                        // matomo analytics code ends 
                        if (result.admission_number){
                            localStorageService.set("className", result.className)

                            localStorageService.set("session_name", result.sessionName)
                            localStorageService.set("curriculum_name", result.curriculumName)
                            localStorageService.set("class_name", result.className)
                            localStorageService.set("batch_name", result.batchName)

                            localStorageService.set("class_id", result.class_id)
                            localStorageService.set("session_id", result.session_id)
                            localStorageService.set("curriculum_id", result.curriculum_id)
                            localStorageService.set("batch_id", result.batch_id)
                        }
                        localStorageService.set("allAcademic_year", result.allAcademic_year)
                        localStorageService.set("is_login", true)
                        localStorageService.set("school_id", result.school_id)
                        localStorageService.set("academic_year", result.academic_year)
                        localStorageService.set("user_id", result.user_id)
                        localStorageService.set("role_ids", result.role_ids)
                        localStorageService.set("full_name", result.name)
                        localStorageService.set("activeAcdYear", result.academic_year)
                        localStorageService.set("admission_no", result.admission_number)
                        localStorageService.set("username", result.username)
                        localStorageService.set("user_image", result.image)
                        localStorageService.set("active_time_check", result.active_time_check)
                        localStorageService.set('login_timestamp', new Date().getTime());
                        localStorageService.set("school_name", result.school_name)

                        if(result.feeDuePopup){
                            localStorageService.set("feedue_popup", result.feeDuePopup);
                            if(result.feedue_popup_message){
                                localStorageService.set("feedue_popup_message", result.feedue_popup_message);
                            }
                        }
                        if(result.bannerstatus){
                                localStorageService.set("bannerstatus", result.bannerstatus);
                        }
                        // if(result.role_ids[0] == "student"){  
                        //     readTextFile("privileges.json", function(text){
                        //         var data = JSON.parse(text);
                        //         console.log("======= Previlage Set From JSON ===========")  
                        //         localStorageService.set("module_privileges", data.modeules)
                        //         localStorageService.set("feature_privileges", data.fatures)
                        //     });
                        // } else {
                        localStorageService.set("module_privileges", result.module_privileges)
                        localStorageService.set("feature_privileges", result.feature_privileges)
                        //}
                        $rootScope.username = result.name

                        //toastr.success("Login success")

                        let userAccessJson = _.filter(localStorageService.get('feature_privileges'), function (feature) {
                            return feature.module_state === "childrenComponent"
                        });
                        if (userAccessJson && userAccessJson.length) {
                            _.each(userAccessJson, function (feature) {
                                let user_access = {};
                                _.each(feature.privilege, function (privObj) {
                                    user_access[privObj.name.toLowerCase()] = privObj.status
                                })
                                localStorageService.set('parent_user_access', user_access);
                                $rootScope.userRoleParentAccess = localStorageService.get('parent_user_access');
                                _.defer(function () {
                                    $scope.$apply();
                                });;
                            })
                        }

                        if(result.password_tracking){ 
                            localStorageService.set("password_tracking", true)
                        } 
 
                        $rootScope.isLoggedIn = true
                        let toredirected = localStorageService.get('toredirected')
                        try {
                            if(toredirected && toredirected.student_id &&
                                toredirected.qp_id && toredirected.page && toredirected.parent_id && toredirected.parent_id ==  result.user_id){
                                    $state.go("activityReportViaLinkCtrl", {
                                        student_id: toredirected.student_id,
                                        qp_id: toredirected.qp_id,
                                        page : toredirected.page,
                                        teacher_id : toredirected.teacher_id,
                                        parent_id : result.user_id
                                    })
                                } else if(result && result.new_users && result.new_users.length
                                     && result.new_users.includes(result.username)){
                                     localStorageService.set("dataEntryUserLogin", true)
                                     $state.go("menutile")
                                }
                                else{
                                    $state.go("dashboard")
                                }   
                        } catch (error) {
                            $state.go("dashboard")
                        }
                       
                    } else {
                        let msg = response.error.error.message
                        toastr.error(msg)
                    }
                })
            } else {
                if (!$scope.newUser.username && !$scope.newUser.password) {
                    toastr.error("Please enter username/password")
                } else if ($scope.newUser.username && !$scope.newUser.password) {
                    toastr.error("Please enter password")
                } else if (!$scope.newUser.username && $scope.newUser.password) {
                    toastr.error("Please enter username")
                }
            }
        }

        $scope.checkEnter = (event) => {
            //if enter login should happen
            event = event || window.event //For IE
            if (event.keyCode === 13) {
                $scope.loginUser();
            }
        }

        this.$onDestroy = () => {
            _hidePrompt()
            $scope.newUser = undefined
        }
        function readTextFile(file, callback) {
            var rawFile = new XMLHttpRequest();
            rawFile.overrideMimeType("application/json");
            rawFile.open("GET", file, true);
            rawFile.onreadystatechange = function () {
                if (rawFile.readyState === 4 && rawFile.status == "200") {
                    callback(rawFile.responseText);
                }
            }
            rawFile.send(null);
        }
        $scope.gsuitLogin = () => {
            localStorageService.set("gLongin", '0')
            _hidePrompt()
            $scope.signOut();
        }

          // Render Google Sign-in button
          $scope.renderButton = () => { 
             //  function renderButton() {
            if(!gapi || !gapi.signin2){
                console.log('missed', gapi.signin2)
                return 
            }
            gapi.signin2.render('gSignIn', {
                'scope': 'profile email',
                'width': 300,
                'height': 42,
                'longtitle': true,
                'theme': 'dark',
                'onsuccess': onSuccess,
                'onfailure': onFailure
            });
        }

        // Sign-in success callback
        function onSuccess(googleUser) {
            // Get the Google profile data (basic)
            //var profile = googleUser.getBasicProfile();

            // Retrieve the Google account data
            gapi.client.load('oauth2', 'v2', function () {
                var request = gapi.client.oauth2.userinfo.get({
                    'userId': 'me'
                });
                request.execute(function (resp) {
                    // Display the user details
                    console.log(resp)
                    var LoggEdmailId = resp.email;
                    console.log(localStorageService.get("gLongin"))
                    console.log('=======================================')
                    //var ndata = LoggEdmailId.includes("hilltop.in"); 
                    if(LoggEdmailId  && (localStorageService.get("gLongin") != '1')){
                        authService.callAPI("/v1/gsuit_login_auth", "POST", resp, function (response) {

                            if (response.result != undefined) {
                                _hidePrompt(3)
                                let result = response.result.data.data[0]        
                                try {
                                    var empOrAdmnNo = result.admission_number ? result.admission_number : result.employeeNo
                                    var userBatchDetails = result.name
                                    if (result.admission_number)
                                        userBatchDetails = result.sessionName + "/" + result.curriculumName + "/" + result.className + "/" + result.batchName + "/" + result.name
                                    _paq.push(['setCustomVariable', 1, "School ID", result.school_name, "visit"]);
                                    _paq.push(['setCustomVariable', 2, "Role IDs", result.role_ids, "visit"]);
                                    _paq.push(['setCustomVariable', 3, "Login Username ", result.quick_login_id, "visit"]);
                                    _paq.push(['setCustomVariable', 4, "Admn No/Emp No ", empOrAdmnNo, "visit"]);
                                    _paq.push(['setCustomVariable', 5, "User Details", userBatchDetails, "visit"]);
                                    _paq.push(['setUserId', result.username]);
                                    _paq.push(['trackPageView']);
                                } catch (e) {
                                    console.log(e);
                                }
                                // matomo analytics code ends
        
                                if (result.admission_number){
                                    localStorageService.set("className", result.className)
                                }
                                localStorageService.set("allAcademic_year", result.allAcademic_year)
                                localStorageService.set("is_login", true)
                                localStorageService.set("school_id", result.school_id)
                                localStorageService.set("school_name", result.school_name)
                                localStorageService.set("academic_year", result.academic_year)
                                localStorageService.set("user_id", result.user_id)
                                localStorageService.set("role_ids", result.role_ids)
                                localStorageService.set("full_name", result.name)
                                localStorageService.set("activeAcdYear", result.academic_year)
                                localStorageService.set("admission_no", result.admission_number)
                                localStorageService.set("username", result.username)
                                localStorageService.set("user_image", result.image)
                                localStorageService.set("active_time_check", result.active_time_check)
                                localStorageService.set('login_timestamp', new Date().getTime());
                                localStorageService.set("full_name", result.name)
                                localStorageService.set("mobile", result.phone)
                                localStorageService.set("user_address", result.addrLine1+","+result.addrLine2+","+result.city+","+result.country)        
                                localStorageService.set("module_privileges", result.module_privileges)
                                localStorageService.set("feature_privileges", result.feature_privileges)
                                $rootScope.username = result.name
        
                                if(result.feeDuePopup){
                                    localStorageService.set("feedue_popup", result.feeDuePopup);
                                    if(result.feedue_popup_message){
                                        localStorageService.set("feedue_popup_message", result.feedue_popup_message);
                                    }
                                }
                                console.log(result.bannerstatus);
                                console.log("result.bannerstatus++++++++++");
                                if(result.bannerstatus){
                                        localStorageService.set("bannerstatus", result.bannerstatus);
                                }

                                // if(result.password_tracking){ 
                                //     localStorageService.set("password_tracking", true)
                                // } 
        
                                let userAccessJson = _.filter(localStorageService.get('feature_privileges'), function (feature) {
                                    return feature.module_state === "childrenComponent"
                                });
                                if (userAccessJson && userAccessJson.length) {
                                    _.each(userAccessJson, function (feature) {
                                        let user_access = {};
                                        _.each(feature.privilege, function (privObj) {
                                            user_access[privObj.name.toLowerCase()] = privObj.status
                                        })
                                        localStorageService.set('parent_user_access', user_access);
                                        $rootScope.userRoleParentAccess = localStorageService.get('parent_user_access');
                                        _.defer(function () {
                                            $scope.$apply();
                                        });;
                                    })
                                }
        
                                console.log("Gsuit Auth")
                                $rootScope.isLoggedIn = true
                                let toredirected = localStorageService.get('toredirected')
                                if(toredirected && toredirected.student_id &&
                                    toredirected.qp_id && toredirected.page &&
                                    toredirected.parent_id &&
                                     toredirected.parent_id ==  result.user_id){
                                        $state.go("activityReportViaLinkCtrl", {
                                            student_id: toredirected.student_id,
                                            qp_id: toredirected.qp_id,
                                            page : toredirected.page,
                                            teacher_id : toredirected.teacher_id,
                                            parent_id : result.user_id
                                        })
                                    }else{
                                        $state.go("dashboard")
                                    }
                            } else {
                                let msg = response.error.error.message;
                                //$scope.signOut();
                                toastr.error(msg);
                                
                            }
                        });    
                    } else {
                       // toastr.error('Please try again..');
                    }                        
                });
            });
        }

        // Sign-in failure callback
        function onFailure(error) {
            // alert(error);
            console.log(error);
            _showPrompt()
        }
        // Sign out the user
        $scope.signOut = () => { 
            var auth2 = gapi.auth2.getAuthInstance();
            auth2.signOut().then(function () {
            console.log('User signed out.');
            });
            auth2.disconnect();


        }

        $scope.passCheck = () => {
            const passwordInput = document.querySelector("#password")
            const eye = document.querySelector("#eye") 
              eye.classList.toggle("fa-eye-slash")
              const type = passwordInput.getAttribute("type") === "password" ? "text" : "password"
              passwordInput.setAttribute("type", type)
           
        }

    }


}

export default LoginController;


// WEBPACK FOOTER //
// ./src/app/login/controllers/loginController.js